import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class RegistryLinkService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.REGISTRY_LINK = '/api/registry-link';
    
        this.GET_BY_ID = '/{id}';
        this.GET_LIST_BY_PROJECT = '/list/project/{projectId}';
    
        this.GET_LIST_BY_REGISTRY = '/list/registry/{registryType}/id/{registryId}';
        this.GET_LIST_BY_REGISTRY_AND_TARGET = '/list/registry/{registryType}/id/{registryId}/target/{targetType}';
        this.GET_LIST_BY_TARGET = '/list/target/{targetType}/id/{targetId}';
        this.GET_LIST_BY_TARGET_AND_REGISTRY = '/list/target/{targetType}/id/{targetId}/registry/{registryType}';
    }

    async getById(id) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK + this.GET_BY_ID;
            url = url
                .replace('{id}', id);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByProject(projectId) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK + this.GET_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }
    
    async getListByRegistryTypeAndRegistryId(registryType, registryId) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK + this.GET_LIST_BY_REGISTRY;
            url = url
                .replace('{registryType}', registryType)
                .replace('{registryId}', registryId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByRegistryTypeAndRegistryIdAndTargetType(registryType, registryId, targetType) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK + this.GET_LIST_BY_REGISTRY_AND_TARGET;
            url = url
                .replace('{registryType}', registryType)
                .replace('{registryId}', registryId)
                .replace('{targetType}', targetType);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByTargetTypeAndTargetId(targetType, targetId) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK + this.GET_LIST_BY_TARGET;
            url = url
                .replace('{targetType}', targetType)
                .replace('{targetId}', targetId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByTargetTypeAndTargetIdAndRegistryType(targetType, targetId, registryType) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK + this.GET_LIST_BY_TARGET;
            url = url
                .replace('{targetType}', targetType)
                .replace('{targetId}', targetId)
                .replace('{registryType}', registryType);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async createRegistryLink(body) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async updateRegistryLink(body) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async deleteRegistryLink(body) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }
}

export default RegistryLinkService;
